/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */
import { writable, get } from 'svelte/store';

let configStore;

/**
 * Create a config store instance.
 * This store holds test-runner configuration.
 * Can be used to access `testRunner.getConfig()` without having to pass `testRunner` instance.
 *
 * @returns {Observable<*>} the store
 */
function createConfigStore() {
    const { subscribe, set } = writable({});
    return {
        subscribe,
        set,
        /**
         * @returns {Object}
         */
        get() {
            return get(this);
        },
        clear() {
            this.set({});
        }
    };
}

/**
 * Get or create config store instance
 * @returns {SvelteStore}
 */
export function getConfigStore() {
    if (!configStore) {
        configStore = createConfigStore();
    }
    return configStore;
}
